@if (visible()) {
  <nav class="pagination" aria-label="Paginação" data-testid="pagination">
    <span class="pagination-range" data-testid="pagination-range">{{ rangeLabel() }}</span>
    <div class="pagination-controls">
      <button
        type="button"
        class="pagination-btn"
        data-testid="pagination-prev"
        [disabled]="!canGoPrevious()"
        aria-label="Página anterior"
        (click)="goToPrevious()"
      >
        Anterior
      </button>
      <span class="pagination-page" data-testid="pagination-page">
        Página {{ currentPage() }} de {{ totalPages() }}
      </span>
      <button
        type="button"
        class="pagination-btn"
        data-testid="pagination-next"
        [disabled]="!canGoNext()"
        aria-label="Próxima página"
        (click)="goToNext()"
      >
        Próxima
      </button>
    </div>
  </nav>
}
